import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getQiwaContractRenewData = createAsyncThunk(
  "api/qiwaContract?renew=1",
  async (token, type) => {
    try {
      const response = await nodeinstance.get("/qiwaContract?renew=1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const QiwaContractDataRenewSlice = createSlice({
  name: "insurance",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getQiwaContractRenewData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getQiwaContractRenewData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getQiwaContractRenewData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getQiwaContractRenewData };
export default QiwaContractDataRenewSlice.reducer;
